import { Router } from '@angular/router';
import { observable, action, } from 'mobx';
import { Injectable } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { AuthService } from 'src/app/auth/auth.service';
import { pushToObject } from 'src/app/services/mapping.service';
import { CONFIG } from 'src/app/dummy/app';

@Injectable()
export class AuthStore {
  @observable user: any = null;
  @observable remember: boolean = false;
  @observable profile: any = null;
  @observable uid: string = null;
  @observable token: string = null;
  @observable data: any = [];
  @observable isLogged: boolean = false;
  @observable process: boolean = false;
  @observable loading: boolean = true;
  @observable company: Array<any> = [];
  @observable selectedCompanyKey: any = null;
  @observable public error = null;
  @observable public displayName = null;
  @observable config: any = null;
  @observable selectedTerm: any = null;

  constructor(
    private ds: DataService,
    private router: Router,
    public auth: AuthService,
  ) { this.fetchCanActive() }


  @action
  async fetchUser() {
    this.user =this.auth.authRef().currentUser;
    const { uid } = this.user;
    this.uid = uid;
    const doc = await this.ds.userProfileRef().doc(uid).get().toPromise();
    this.profile = pushToObject(doc);
    const { organizationKey } = this.profile;
    this.selectedCompanyKey = organizationKey || null;
  }


  @action
  async fetchEnvironment() {
    const docs = await this.ds.environmentRef().get().toPromise();
    const config: any = pushToObject(docs);
    this.config = config;

    // const {termKey,PROGRAM}=config;
    // CONFIG.PROGRAM = PROGRAM
    // this.ds.termRef().doc(termKey).valueChanges().subscribe(doc=>{
    //   this.selectedTerm=doc;
    // })
    return config;
  }

  @observable fetchCanActiveRef: any = null;
  @observable fetchCanActiveFnRef: any = null;
  @action
  fetchCanActive() {
    this.loading = true;
    this.ds.collection('user').valueChanges().subscribe(doc=>{
    })
    this.fetchCanActiveFnRef = this.auth.canActiveRef().subscribe(async user => {
      this.loading = true;
      this.user = user;
      this.displayName = null;
      if (user) {
        this.uid = user.uid;
        this.displayName = user.displayName;
        this.user = {
          key: user.uid,
          name: user.displayName,
          email: user.email,
          uid: user.uid,
        }
        this.fetchCanActiveRef = this.ds.userProfileRef().doc(user.uid).valueChanges().subscribe((list: any) => {
          this.profile = list;
          this.selectedCompanyKey = list ? list.organizationKey : null;
          if (list && list.organizationKey)
            localStorage.setItem("selected_company", JSON.stringify(list.organizationKey, getCircularReplacer()))
          this.loading = false;
        })
      }
      else {
        this.loading = false
      }
    })
  }

  @action
  fetchSelectedCompany() {
    const company = localStorage.getItem("selected_company");
    if (company) this.selectedCompanyKey = JSON.parse(company);
  }

  @action
  signIn(form: any, callback) {
    const { email, password } = form;
    this.process = true;
    this.auth.authRef().signInWithEmailAndPassword(email, password).then(async user => {
      if (user) {
        this.user = user.user;
        this.router.navigate(['/'])
        this.process = false;
        return user;
      }
      else {
        this.error = "Invalid email and password.";
        this.process = false;
        return null;
      }
    }).catch(error => {
      this.process = false;
      callback(false, error);
    });
  }

  @action
  signOut(callback) {
    this.fetchCanActiveRef && this.fetchCanActiveRef.unsubscribe();
    this.fetchCanActiveFnRef && this.fetchCanActiveFnRef.unsubscribe();

    this.auth.signOut().then(() => {
      this.company = null;
      this.selectedCompanyKey = null;
      this.process = false;
      callback(true, null);
    }).catch(error => {
      this.process = false;
      callback(false, error);
    });
  }


  @action
  fetchCurrentUser() {
    return this.auth.authRef().currentUser;
  }

  @action
  getUser() {
    const { uid, displayName, email, phoneNumber, photoURL } = this.auth.authRef().currentUser
    return {
      key: uid,
      displayName,
      email,
      phoneNumber,
      photoURL,
      uid,
    }
  }

  @action
  resetPassword(email) {
    return this.auth.authRef().sendPasswordResetEmail(email);
  }


}


const getCircularReplacer = () => {
  const seen = new WeakSet();
  return (key, value) => {
    if (typeof value === "object" && value !== null) {
      if (seen.has(value)) {
        return;
      }
      seen.add(value);
    }
    return value;
  };
};
